import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
import { getComponentContentById } from "@cappelendamm/crystallize-utils";
const BOOK_CLUB_IDS = CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB;
export const getSubscriptionVariantEndingInvoice = (subscription) => {
    const endingInvoiceContent = getComponentContentById(subscription.components, BOOK_CLUB_IDS.VARIANT.ENDING_INVOICE.ID);
    if (!endingInvoiceContent || !endingInvoiceContent.chunks?.length)
        return undefined;
    if (endingInvoiceContent.__typename !== "ContentChunkContent")
        throw new Error(`Ending invoice is not of type content chunk - Sku ${subscription?.sku}`);
    const endingInvoice = endingInvoiceContent.chunks
        .map((chunk) => {
        const invoice = chunk.reduce((acc, { componentId: id, content }) => {
            if (id === BOOK_CLUB_IDS.VARIANT.ENDING_INVOICE.INVOICE_PRODUCT &&
                content?.__typename === "ItemRelationsContent") {
                const variant = content.productVariants?.[0];
                if (!variant)
                    return acc;
                return {
                    ...acc,
                    sku: variant.sku,
                    name: variant.name,
                    image: variant.images?.find(({ url }) => url)?.url,
                    price: variant.priceVariants?.[0]?.price,
                };
            }
            if (id === BOOK_CLUB_IDS.VARIANT.ENDING_INVOICE.ALTERNATIVE_PRICE &&
                content?.__typename === "NumericContent") {
                return {
                    ...acc,
                    alternativePrice: content.number ?? undefined,
                };
            }
            return acc;
        }, {});
        return invoice;
    })
        .find((invoice) => Boolean(invoice && invoice.sku));
    return endingInvoice;
};
